import { Component, OnInit, Input, forwardRef, ViewChild } from '@angular/core';
import { BaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'text-input-control',
  templateUrl: './text-input-control.component.html',
  styleUrls: ['./text-input-control.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TextInputControlComponent,
    multi: true
  }]
})
export class TextInputControlComponent extends BaseControl {
  @Input() public icon: string = '';
  @Input() public iconSize: string = 'lg';
  @Input() public prependIcon: boolean = false;

  @Input() public isTextarea: boolean = false;
  @Input() public textareaRows: number = 3;
  @Input() public type: string = 'text';
  @Input() public ignoreRows: boolean = false;
  @Input() public showAsDiv: boolean = false;

  @ViewChild('textArea') public textArea: HTMLTextAreaElement;

  textareaHeight: string = '';

  constructor() {
    super();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    if (this.isTextarea && this.ignoreRows && !this.showAsDiv) {
      setTimeout(() => {
        if (this.textArea['nativeElement'].scrollHeight > this.textArea['nativeElement'].clientHeight) {
          this.textareaHeight = (this.textArea['nativeElement'].scrollHeight + 50) + 'px';
          this.updateValue();
        }
      }, 1000);
    }
    else {
      setTimeout(() => {
        this.updateValue();
      }, 1000);
    }
  }

  onWriteValue(value) {
    if (value && this.ignoreRows && this.isTextarea) this.textareaRows = value.split(/\r\n|\r|\n/).length;
  }

}
